import { fetcher } from "helpers/fetcher";

import { TGetStaffStatusListReq, TGetStaffStatusListRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffStatusList = async (staffId: string) => {
  return await fetcher<TGetStaffStatusListRes, TGetStaffStatusListReq>(
    ENDPOINT.CORPORATION.GET_STAFF_STATUS_LIST,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.GET_CORPORATION_BASIC_INFO.version,
        [API_HEADER.USER_ID]: staffId,
      },
    }
  );
};

export const queryGetStaffStatusList = async (staffId: string) => {
  return (await getStaffStatusList(staffId)).data;
};

queryGetStaffStatusList._key = (staffId: string) => [
  ENDPOINT.CORPORATION.GET_STAFF_STATUS_LIST.url,
  staffId,
];
